import { FunctionComponent } from 'react'

import useAppTheme from '@hooks/useAppTheme'
import ArticleTextboxComponents from '@components/ArticleTextbox'

import TextboxImage from './TextboxImage'
import { ArticleTextBoxImage } from './types'

const { Caption, CaptionCreditWrapper, Credit, ImageTextWrapper } =
  ArticleTextboxComponents

interface TextBoxImageWrapperProps {
  image?: ArticleTextBoxImage
  imageDark?: ArticleTextBoxImage
  noTextHalfWidth?: boolean
  isPromo?: boolean
}

const TextBoxImageWrapper: FunctionComponent<TextBoxImageWrapperProps> = ({
  image,
  imageDark,
  noTextHalfWidth = false,
  isPromo = false,
}) => {
  const appTheme = useAppTheme()
  const themedImage = appTheme === 'dark' && imageDark ? imageDark : image
  const {
    alignment: imageAlignment = 'full-width',
    credit,
    caption,
  } = themedImage ?? {}

  if (!image) return null

  return (
    <ImageTextWrapper
      alignment={imageAlignment}
      noTextHalfWidth={noTextHalfWidth}
    >
      <TextboxImage isPromo={isPromo} imageDark={imageDark}>
        {image}
      </TextboxImage>
      <CaptionCreditWrapper>
        {caption ? <Caption>{caption}</Caption> : null}
        {credit?.text && credit?.link?.href ? (
          <Credit
            blinkProps={{
              ...credit.link,
              inTextBox: true,
              brandedBox: false,
            }}
          >
            {credit.text}
          </Credit>
        ) : null}
        {credit?.text ? <Credit>{credit.text}</Credit> : null}
      </CaptionCreditWrapper>
    </ImageTextWrapper>
  )
}

export default TextBoxImageWrapper
